import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import {
  IoMdLeaf,
  IoMdSunny,
  IoMdNutrition,
  IoMdFemale,
  IoMdPeople,
  IoMdGitNetwork,
  IoMdCheckmarkCircle
} from "react-icons/io";


import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';


import cln1 from '../assets/banner1.jpg';
import cln2 from '../assets/banner7.jpg';
import cln3 from '../assets/banner3.jpg';
import cln4 from '../assets/banner5.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
											}}
										>
											Sustainable Agriculture
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">

								<HorizontalImageStrip
									images={[cln1, cln2, cln3, cln4]}
								/>

								<h6
									style={{
										fontSize: "18px",
										marginTop: "45px",
										marginBottom: "35px",
										textTransform: "uppercase",
										textAlign: "center"
									
									}}
								>
									At FPADI, we believe that &nbsp; 
									<span className="text-secondary"><b>sustainable agriculture</b></span> &nbsp;  is essential to achieving &nbsp;
									<span className="text-secondary"><b>sustainable development</b></span> &nbsp;
									<hr />
								</h6>

								<h5>
									he total GDP. It is the livelihood of 65 to 70% of the population and accounts for about three-quarters of rural incomes. In Tanzania, smallholder farmers dominate agriculture, occupy a large portion of the farms, and produce most crop and livestock products. These smallholder farmers play a vital role in agricultural production and food security. Despite efforts, agriculture has failed to become an engine of growth and economic transformation due to constraints along the value chain. 
									<br/><br/>
									These constraints include land tenure and management, access to input and output markets, access to agricultural extension and agricultural credit services, and the risk posed by climate change. Poverty is directly linked to food insecurity and poor agricultural performance among smallholder farmers. It is a fact that agriculture contributes to global warming through anthropogenic greenhouse gas emissions by converting non-agricultural land such as forests into agricultural land.
									<br/><br/>
									Sustainable agriculture is essential to achieving sustainable development. At FPADI, we are committed to promoting sustainable agriculture practices that empower farmers, increase productivity, and protect the environment. We believe that by promoting sustainable agriculture practices, we can create a more resilient and sustainable food system.
									<br/><br/>
									Our Sustainable Agriculture service focuses on providing farmers with training on sustainable agriculture practices such as agroforestry, conservation agriculture, and integrated pest management. We work with farmers to develop sustainable farming practices that are environmentally sustainable and economically viable. We believe that by empowering farmers to adopt sustainable practices, we can increase productivity and improve food security while protecting the environment.
									<br/><br/>
									We also provide access to resources such as improved seeds, fertilizer, and irrigation systems that help farmers increase their yields and improve their livelihoods. We work with communities to create market linkages that ensure farmers have access to markets where they can sell their produce at fair prices.
								</h5>

								
							</div>

						</div>

					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}